import styled from "styled-components";
import { FormControlLabel, List } from "@material-ui/core";
import { primary, SmallUserAvatarStyle } from "../../shared/Style/Style";

interface IModalInputCustomProps {
  error?: boolean;
}

export const ModalInput = styled.input<IModalInputCustomProps>`
  appearance: textfield;
  width: 200px;
  text-align: center;
  outline: none;
  border-style: solid;
  border-width: 0 0 1px 0;
  color: ${(props) => (props?.error ? "red" : "inherit")};
  border-color: ${(props) =>
    props?.error
      ? "transparent transparent #ff1111 transparent"
      : "transparent transparent #bbb transparent"};
  font-size: 14px;
  line-height: 16px;
  transition: border-color 0.3s, color 0.3s;
  &:focus {
    border-color: ${(props) =>
      props?.error
        ? "transparent transparent #ff1111 transparent"
        : `transparent transparent ${primary} transparent`};
    color: ${(props) => (props?.error ? "red" : "inherit")};
  }
  &::-webkit-outer-spin-button {
    display: none;
  }
  &::-webkit-inner-spin-button {
    display: none;
  }
`;

export const ClientsList = styled(List)`
  max-height: 240px;
  overflow-y: auto;
`;

export const ClientLabel = styled(FormControlLabel)`
  width: 100%;
`;

export const ClientAvatar = styled(SmallUserAvatarStyle)`
  width: 36px;
  height: 36px;
`;
